<template>
	<div class="setting-join-gzh">
		<div class="module-item-style" v-if="currentRoute">
			<div class="module-item-title">微信公众号接入</div>
			<div class="join-tips">
				绑定后你可以使用微聊统一接收与回复顾客咨询。
			</div>
			<div class="wl-btn" @click="showBindDialog">去微信平台授权绑定</div>
			<ul class="join-result">
				<li><span>*</span>你的公众号必须是认证过的微信订阅号或服务号，否则无法正常回复顾客对话；
				</li>
				<li><span>*</span>绑定后，你之前设置好的菜单、自动回复等功能仍然有效。</li>
			</ul>
			<ul class="join-content-container">
				<li class="bind-item" v-for="(item, i) in gzhList" :key="i">
					<div class="join-logo">
						<img src="@/assets/images/wx_logo.png" alt="">
					</div>
					<div class="join-type-container">
						<div class="bind-name">{{item.wxName}}<span> | <span v-if="item.isSuccess == 1">正常</span><span v-else>发起对话检测</span></span></div>
						<ul class="bind-type">
							<li v-if="item.isSuccess == 1"><i></i>正常</li>
							<li v-else><i></i>请发起状态检测状态</li>
						</ul>
					</div>
					<div class="join-operation-container">
						<div class="join-customService-container wl-btn unbind-wl choose-service">
							<el-popover @show="getCsId(item.csInfoList)" @hide="updateBindService(item)" :ref="refNamePopover+item.id" placement="bottom" v-model="item.visible" trigger="click">
								<div class="service-tree-container">
									<el-tree :data="treeData" 
										show-checkbox 
										class="service-tree" 
										node-key="id" ref="tree" 
										highlight-current
										@check-change="chooseService"
										:default-checked-keys="item.selectServiceList">
									</el-tree>
									<div class="comfirm-btn" @click="hidePopover(item)">确认</div>
								</div>
								<div class="service-text" slot="reference" :title="item.checkedServiceName">{{item.checkedServiceName}}</div>
							</el-popover>
						</div>
						<span class="wl-btn unbind-wl menu" @click="toNextPage(item.id,'menu')">微信菜单</span>
						<span class="wl-btn unbind-wl auto-reply" @click="toNextPage(item.id,'reply')">自动回复</span>
						<span class="wl-btn unbind-wl unbind" @click="unbindWL(item.id)">解除绑定</span>
					</div>
				</li>
			</ul>
		</div>
		<transition name="fade-transform" mode="out-in">
			<router-view v-if="!currentRoute" />
		</transition>

		<el-dialog title="去微信平台授权绑定" width="570px" :visible.sync="dialogFormVisible">
			<div>
				<el-input class="appid-input" v-model="appId" placeholder="指定APP ID(非必填)"></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="toWechat">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'setting-join-gzh',
		data() {
			return {
				dialogFormVisible: false,
				appId: '',
				gzhList: [],
				auth_code: this.$route.query.auth_code,
				expires_in: this.$route.query.expires_in,
				treeData: [],
				selectServiceList: [],
				checkedServiceName: '点击选择客服',
				refNamePopover: 'popover-', // popover ref名称前缀
			}
		},
		created() {
			this.getGzhList()
		},
		mounted() {
			if (this.auth_code && this.expires_in) {
				this.bindUrlCallback()
			}
		},
		computed: {
			currentRoute() {
				let route = this.$route
				if (route.name == 'settingJoinGzh') {
					return true
				} else {
					return false
				}
			},
		},
		watch: {
			'$route'(to, from) {
				if (to.name == 'settingJoinGzh') {
					this.getGzhList()
				}
			}
		},
		methods: {
			showBindDialog() {
				this.appId = ''
				this.dialogFormVisible = true
			},
			toWechat() {
				this.initBindcus()
			},
			toNextPage(id, type) {
				let pathName = ''
				if (type == 'menu') {
					pathName = 'settingJoinGzhMenu'
				} else if (type == 'reply') {
					pathName = 'settingJoinGzhReply'
				}
				this.$router.push({
					name: pathName,
					query: {
						id
					}
				})
			},
			unbindWL(id) {
				let authType = '1' // 1是公众号 2是小程序
				this.$confirm('将要进行解绑操作, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.unbindWechatAPI({
						gzhId: id,
						authType
					}).then(res => {
						if (res.status == 1) {
							this.getGzhList()
							this.$message({
								message: res.msg,
								type: 'success',
							})
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							})
						}
					})
				}).catch(() => {})
			},
			initBindcus() {
				this.$http.initGzhBindUrlAPI({
					biz_appid: this.appId
				}).then(res => {
					if (res.status == 1) {
						window.location.href = res.data.bindcomponentURL
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			bindUrlCallback() {
				this.$http.getGzhRedirectUrlAPI({
					"auth_code": this.auth_code,
					"expires_in": this.expires_in,
					"auth_type": "1"
				}).then(res => {
					if (res.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
					window.location.href = res.data.redirectUrl
				})
			},
			getGzhList() {
				this.$http.getGzhListAPI().then(res => {
					console.log(res)
					if (res.status == 1) {
						this.gzhList = res.data
						this.gzhList.forEach((item,index) => {
							item.checkedServiceName = "请选择客服"
							item.visible = false
							item.selectServiceList = [];
							if(item.csInfoList.length){
								let csNameList = [];
								item.csInfoList.forEach((_item,index) => {
									csNameList.push(_item.csName)
									item.selectServiceList.push(_item.csId)
								})
								item.checkedServiceName = csNameList.join("、")
							}
						})
						this.getService()
					}
				})
			},
			// popover显示时展示已经选择的客服 以便后面点击确定的时候selectServiceList有数据
			getCsId(list) {
				this.selectServiceList = [];
				list.map(item => {
					this.selectServiceList.push(item.csId)
				})
			},
			// 获取客服列表
			getService() {
				let postParams = {
					pageNum: "1",
					pageSize: "99",
					name: "",
					type: ""
				}
				this.$http.getServiceListAPI(postParams).then(res => {
					console.log(res)
					if (res.status == 1) {
						let serviceData = res.data.csList
						let newServiceTree = []
						// 将后台返回的数据转换成Element tree所需的数据格式
						serviceData.map(item => {
							newServiceTree.push({
								id: item.csId,
								label: item.csName
							})
						})
						this.treeData = newServiceTree
					}
				}).catch(err => {
					
				})

			},
			// 选择客服
			chooseService(data, checked) {
				if (checked) {
					if (this.selectServiceList.indexOf(data.id) > -1) {
						return false;
					} else {
						this.selectServiceList.push(data.id)
					}
				} else {
					this.selectServiceList.splice(this.selectServiceList.findIndex(item => item === data.id), 1)
					// this.selectServiceList = this.selectServiceList.filter(i => i!=data.id);
				}
			},
			hidePopover(item){
				let refName = this.refNamePopover + item.id;
				this.$refs[refName][0].doClose();
			},
			// 绑定公众号客服
			updateBindService(item) {
				let postData = {
					gzhId: item.id,
					csIds: this.selectServiceList
				}
				if(JSON.stringify(this.selectServiceList)==JSON.stringify(item.selectServiceList)){
					// 选中的客服和之前选中的客服相等时 说明没进行操作 不发送数据
					return false
				}
				if (this.selectServiceList.length || item.csInfoList.length) {
					this.$http.gzhBindCs(postData).then(res => {
						if (res.status == 1) {
							this.getGzhList()
							this.$message({
								message: res.msg,
								type: 'success',
							})
						}
					}).catch(err => {

					})
				} else {
					this.$message({
						message: "请先选择客服",
						type: 'warning',
					})
					return false;
				}
			},
			
		}
	}
</script>

<style lang="scss">
	.setting-join-gzh {
		.join-tips {
			font-size: 12px;
			color: #999;
			line-height: 40px;
		}

		.join-result {
			padding: 15px;

			li {
				line-height: 22px;
				padding-bottom: 5px;

				span {
					color: #FF4E00;
					font-size: 16px;
					display: inline-block;
					padding-right: 8px;
				}
			}
		}

		.join-content-container {

			.bind-item {
				font-size: 12px;
				display: flex;
				background: rgba(255, 255, 255, 1);
				border: 1px solid rgba(228, 231, 237, 1);
				border-radius: 6px;
				padding: 15px;
				align-items: center;
				margin-bottom: 10px;

				.join-logo {
					margin-right: 10px;

					img {
						width: 41px;
						height: 40px;
					}
				}

				.join-type-container {
					.bind-name {
						padding: 0 5px 8px 0;
						font-size: 14px;
						font-weight: bold;
						line-height: 18px;

						&>span {
							font-size: 12px;
							color: #999;
							font-weight: normal;
						}
					}

					.bind-type {
						font-size: 13px;
						padding: 0;
						color: $mainColor;

						li {
							display: flex;
							align-items: center;
						}

						i {
							width: 5px;
							height: 5px;
							border-radius: 50%;
							background-color: $mainColor;
							margin-right: 8px;
						}
					}
				}

				.join-operation-container {
					margin-left: auto;
					display: flex;
					align-items: center;

					.unbind-wl {

						background-color: #fff;

						&.unbind {
							border: 1px solid #14A4E7;
							color: #14A4E7;
						}

						&.auto-reply {
							border: 1px solid #28C121;
							color: #28C121;
						}

						&.menu {
							border: 1px solid #FA8322;
							color: #FFF;
							background-color: #FA8322;
						}

						&.choose-service {
							border: 1px solid $mainColor;
							color: $mainColor;
							background-color: #fff;
						}

						&.choose-service,
						&.choose-service .service-text {
							max-width: 200px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}

					.unbind-wl+.unbind-wl {
						margin-left: 10px;
					}
				}
			}
		}
	}

	.service-tree-container {
		overflow: auto;
		width: 211px;
		display: flex;
		flex-direction: column;
		margin: 0 -12px -12px;

		.service-tree {
			height: 240px;
			overflow: auto;
			padding: 0 12px;
		}

		.comfirm-btn {
			flex: 1;
			background-color: $mainColor;
			text-align: center;
			color: #fff;
			line-height: 30px;
			cursor: pointer;
		}
	}

	.el-tree-node__label {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 13px;
	}

	.el-tree-node__expand-icon.is-leaf {
		display: none;
	}
</style>
